import { render, staticRenderFns } from "./twoCourse.vue?vue&type=template&id=d7248968&scoped=true&"
import script from "./twoCourse.vue?vue&type=script&lang=js&"
export * from "./twoCourse.vue?vue&type=script&lang=js&"
import style0 from "./twoCourse.vue?vue&type=style&index=0&id=d7248968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7248968",
  null
  
)

export default component.exports